import { CommonModule } from '@angular/common';
import {
  ModuleWithProviders,
  NgModule,
  inject,
  provideAppInitializer,
} from '@angular/core';

import { AnalyticsWrapperService } from '@ts/analytics/shared/data-access';
import { AuthenticationService } from '@ts/shared/authentication/data-access';

import { initUserService } from './user-init';
import { UserStreamService } from './user-stream.service';

@NgModule({
  imports: [CommonModule],
})
export class UserSharedDataAccessModule {
  static forRoot(): ModuleWithProviders<UserSharedDataAccessModule> {
    return {
      ngModule: UserSharedDataAccessModule,
      providers: [
        provideAppInitializer(() => {
          const initializerFn = initUserService(
            inject(AuthenticationService),
            inject(UserStreamService),
            inject(AnalyticsWrapperService),
          );
          return initializerFn();
        }),
      ],
    };
  }
}
